import {css} from 'lit';
export const styles = css`.page-content{display:flex;flex-direction:column;gap:2rem}`;
export default styles;
